import { Children, ReactNode, RefObject } from 'react';

import {
  ActionBar,
  ActionBarMui,
  FilterBar,
} from '@spotify/confidence-core-react';

import { WrapperEntry } from '../Wrapper/composition';
import { isFiltersProvider } from '../Wrapper/presets/isFiltersProvider';

type UseActionBarMuiArgs = {
  wrapperElements: WrapperEntry[];
  actionBar: ReactNode;
  actionBarRef: RefObject<HTMLDivElement | null>;
  actionBarTopOffset: number;
};

export const useActionBarMui = ({
  wrapperElements,
  actionBar,
  actionBarRef,
  actionBarTopOffset,
}: UseActionBarMuiArgs): ReactNode => {
  const hasFiltersProvider = wrapperElements.some(entry =>
    isFiltersProvider(entry.element.type),
  );

  if (!actionBar && !hasFiltersProvider) return null;

  const userActions = Children.toArray(actionBar);
  const filterBarHasNoSiblings = hasFiltersProvider && userActions.length === 0;

  const actionBarChildren = hasFiltersProvider
    ? [
        <FilterBar key="auto-filter-bar" />,
        ...userActions,
        ...(filterBarHasNoSiblings
          ? [<span key="end-anchor" aria-hidden />]
          : []),
      ]
    : actionBar;

  const ActionBarComponent = hasFiltersProvider ? ActionBar : ActionBarMui;

  return (
    <ActionBarComponent ref={actionBarRef} topOffset={actionBarTopOffset}>
      {actionBarChildren}
    </ActionBarComponent>
  );
};
